module.exports = __webpack_public_path__ + "img/mdt-logo-2.93c1c225.png";